import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import { connect } from 'react-redux';
import {
    getPromocode,
    updateCart,
    emptyCart,
    getCartItems,
    getCartItemsLocal,
    toggleSignUp,
    placeNewOrder,
    successReport,
    getUserDetails,
    pushEvent
} from '../../../store/actions/user/User';
import { saveEventData } from "../../../utils/events-handler"
import { Typography, withStyles } from '@material-ui/core';
import ProductCard from '../Cart/ProductCheckoutCart';
import PlacesWithStandaloneSearchBox from "../Home/map";
import StripeCheckout from "../Cart/StripeCheckout";
import CheckoutForm from '../Checkout/CartCheckoutForm';
import Divider from '@material-ui/core/Divider';
import GridItem from "../../../components/Grid/GridItem.js";
import GridContainer from "../../../components/Grid/GridContainer.js";

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Loader from "../../Loader/Loader";


const styles = (theme) => ({
    container: {
        minHeight: 'calc(100vh)',
        paddingTop: '9%',
        background: 'rgb(240, 245, 247)',
        [theme.breakpoints.down('sm')]: {
            paddingTop: '20%',
        }
    }
})


var promocode = ''
class CartCheckout extends Component {

    constructor(props) {
        super(props)
        this.calculateTotal = this.calculateTotal.bind(this)
        this.renderInvoice = this.renderInvoice.bind(this)
        this.renderCart = this.renderCart.bind(this)
        this.renderPayementCondition = this.renderPayementCondition.bind(this)
        this.handlePaymentOptionChange = this.handlePaymentOptionChange.bind(this);
    }

    state = {
        promocode: 'Promo code not valid',
        color: 'red',
        flag: false,
        msg: '',
        disabled: false,
        show: false,
        paymentOption: null,
        showPaymentGateway: false,
        eventsApiCall: null,
        showLoader: false,
    };

    componentDidMount() {
        if (this.props.auth) {
            this.props.getCartItems();
            this.props.getUserDetails();
        } else {
            this.props.getCartItemsLocal()
        }
        saveEventData(this.props.pushEvent, "CheckoutPage")
        let eventsApiCall = setInterval(() => {
            saveEventData(this.props.pushEvent, "CheckoutPage")
        }, 120000)
        this.setState({
            eventsApiCall: eventsApiCall
        })
    }

    componentWillUnmount() {
        const eventsApiCall = this.state
        if (eventsApiCall) {
            clearInterval(eventsApiCall)
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.cart !== this.props.cart || prevProps.coupon !== this.props.coupon) {
            this.calculateTotal()
        }
        if (prevProps.auth !== this.props.auth) {
            if (this.props.auth) {
                this.props.getCartItems();
                this.props.getUserDetails();
            } else {
                this.props.getCartItemsLocal()
            }
        }
    }

    calculateTotal() {
        const props = this.props
        let variant_price = 0;
        var c = 0;
        const total = props.cart
            ? props.cart.map(
                (item) => (c += parseFloat(item.products[0]?.isOffer ? item.products[0]?.offerPrice : item.products[0]?.price) * parseFloat(item.products[0].isGm || item.products[0].isMl ? item.quantity / 10 : item.quantity).toFixed(2))
            )
            : 0;
        const total_variant = props.cart
            ? props.cart.map(
                (item) => (
                    item.variant && item.variant.map((v) =>
                        variant_price += parseFloat(v.price) * parseFloat(item.products[0].isGm || item.products[0].isMl ? item.quantity / 10 : item.quantity).toFixed(2)
                    )
                )
            )
            : 0;
        const t = (total[total.length - 1] + variant_price).toFixed(2);
        const pc = props.coupon && props.coupon.discountType ? props.coupon : (props.cart && props.cart.length > 0 ? props.cart[0].coupon : {});

        var gt = 0;
        var p;
        if (pc && pc.discountType === 'FIXED') {
            p = pc.value;
            gt = t - p;
        } else if (pc && pc.discountType === 'PERCENTAGE') {
            p = (pc.value * t) / 100;
            gt = t - p;
        } else if (pc && pc.discountType !== undefined) {
            p = 0;
            gt = t;
        } else {
            p = 0;
            gt = t;
        }
        if (gt < 0) {
            gt = 0
        }
        localStorage.setItem('totalCost', parseFloat(gt) + (4.00) * this.props.vendorWiseCart?.length);
        localStorage.setItem('promoCost', p);
        localStorage.setItem('cost', t);
        this.setState({
            't': t,
            'p': p,
            'gt': (parseFloat(gt) + (4.00) * this.props.vendorWiseCart?.length).toFixed(2)
        })
    }

    renderDot(fillDot) {
        return (<div style={{
            boxSizing: 'border-box',
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            border: '3px solid rgba(183, 186, 195, 0.2)'
        }}>

            {fillDot ? <div style={{
                boxSizing: 'border-box',
                display: 'flex',
                '-webkit-box-align': 'center',
                alignItems: 'center',
                '-webkit-box-pack': 'center',
                justifyContent: 'center',
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                border: 'none',
                backgroundColor: 'rgb(1, 160, 90)'
            }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 7" height="9px" width="14px" fill="white" class="sc-64ptou-0 ifUlNW"><polygon points="6.615 11.549 12.25 5.914 11.59 5.254 6.615 10.228 4.656 8.269 3.996 8.93" transform="translate(-4 -5)"></polygon></svg></div>
                : <div style={{
                    boxSizing: 'border-box',
                    display: 'flex',
                    '-webkit-box-align': 'center',
                    alignItems: 'center',
                    '-webkit-box-pack': 'center',
                    justifyContent: 'center',
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    border: '4px solid rgb(183, 186, 195)'
                }}>

                </div>}
        </div>)
    }

    clearTheCart() {
        this.props.emptyCart().then((data) => {
            this.props.getCartItems();
        });
    };

    handleSignIn() {
        this.props.toggleSignUp(true);
        this.setState({ signOpen: true });
    }

    renderSignIn() {
        return (<div>
            <h4>{'Sign in to place your order'}</h4>
            <p>New to Grospick? Sign up now to get started! Or log in to your existing account.</p>
            <div onClick={this.handleSignIn.bind(this)} style={{
                width: '222px',
                height: '54px',
                background: 'rgb(1, 160, 90)',
                border: '1px solid rgb(1, 160, 90)',
                color: '#fff',
                borderRadius: '30px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-around',
                padding: '0 5px',
                userSelect: 'none',
                '&:hover': {
                    boxShadow: '1px 1px 2px #000000'
                }
            }}>
                <div >Sign In</div>
            </div>
        </div>)
    }

    handleAddressSave(checkoutAddress) {
        this.setState({
            addressSaved: true,
            checkoutAddress
        })
    }

    renderAddress(auth) {
        const { userDetails } = this.props
        return (<div>
            <div style={{ display: 'flex' }}>
                <h4 style={{ color: auth ? 'black' : '#A09E9E', flexGrow: '1' }}>Add delivery address</h4>
                {this.state.addressSaved &&
                    <div onClick={() => {
                        this.setState({
                            addressSaved: false
                        })
                    }} style={{
                        width: '53px',
                        height: '22px',
                        background: 'rgb(1, 160, 90)',
                        border: '1px solid rgb(1, 160, 90)',
                        color: '#fff',
                        borderRadius: '30px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-around',
                        padding: '0 5px',
                        userSelect: 'none',
                        '&:hover': {
                            boxShadow: '1px 1px 2px #000000'
                        },
                        fontSize: '10px'
                    }}>
                        <div>Change</div>
                    </div>
                }
            </div>
            {auth ?
                <CheckoutForm handleAddressSave={this.handleAddressSave.bind(this)} addressSaved={this.state.addressSaved} userDetails={userDetails} />
                :
                <p style={{ color: '#A09E9E' }}>Choose your delivery address from address book or add new</p>
            }
        </div>)
    }

    proceedToPayment = (token) => {
        const { cart } = this.props;
        var tempPayload = { ...this.state.checkoutAddress, payment_token: token?.id };
        tempPayload.cart = cart
        tempPayload.orderType = '1'
        this.setState({
            disablePayment: true,
            showLoader: true
        })
        this.props.placeNewOrder(tempPayload).then(async (data) => {
            await this.props.emptyCart();
            await this.props.getCartItems();
            this.props.successReport('Order Places Successfully')
            this.props.history.push('/')
            this.setState({
                disablePayment: false,
                showLoader: false
            })
        }).catch(err => {
            this.setState({
                disablePayment: false,
                showLoader: false
            })
        })
    };

    handlePaymentOptionChange = (event) => {
        if (event.target.value === 'wallet' || event.target.value === 'rechargeWallet') {
            var tempPayload = { ...this.state.checkoutAddress, useWallet: true };
            this.setState({
                checkoutAddress: tempPayload
            })
        }
        this.setState({
            paymentOption: event.target.value,
        })
    };

    handleProceedToPay = () => {
        const { paymentOption } = this.state
        if (paymentOption === 'wallet') {
            this.setState({
                disablePayment: true
            })
            this.proceedToPayment({ id: 'NOT_REQUIRED' })
        } else {
            this.setState({
                showPaymentGateway: true,
            })
        }
    }

    renderPayementCondition() {
        const { userDetails } = this.props
        const { gt, paymentOption, showPaymentGateway, disablePayment } = this.state;
        if (!showPaymentGateway && userDetails.walletAmount && userDetails.walletAmount >= gt) {
            return <FormControl component="fieldset">
                <FormLabel component="legend">Choose Payment Option</FormLabel>
                <RadioGroup aria-label="paymentOption" name="paymentOption" value={paymentOption} onChange={this.handlePaymentOptionChange.bind(this)}>
                    <FormControlLabel value="wallet" control={<Radio />} label={`Use Wallet Balance (Wallet Balance ${userDetails.walletAmount})`} />
                    <FormControlLabel value="card" control={<Radio />} label="Pay By Card" />
                </RadioGroup>
                <div style={{ display: "flex", justifyContent: "space-around" }}>
                    <button
                        className="site-btn btnAdd submit-order-btn"
                        style={{ color: !paymentOption ? "black" : "white", background: !paymentOption ? "#ffffff" : "rgb(1, 160, 90)" }}
                        disabled={!paymentOption || disablePayment}
                        onClick={this.handleProceedToPay.bind(this)}
                    >
                        Proceed To Pay
              </button>
                </div>
            </FormControl>
        }
        else if (!showPaymentGateway && userDetails.walletAmount && userDetails.walletAmount < gt) {
            return <FormControl component="fieldset">
                <FormLabel component="legend">Choose Payment Option</FormLabel>
                <RadioGroup aria-label="paymentOption" name="paymentOption" value={paymentOption} onChange={this.handlePaymentOptionChange.bind(this)}>
                    <FormControlLabel value="rechargeWallet" control={<Radio />} label={`Racharge Wallet and Pay (Wallet Balance ${userDetails.walletAmount})`} />
                    <FormControlLabel value="card" control={<Radio />} label="Pay By Card" />
                </RadioGroup>
                <div style={{ display: "flex", justifyContent: "space-around" }}>
                    <button
                        className="site-btn btnAdd submit-order-btn"
                        style={{ color: !paymentOption ? "black" : "white", background: !paymentOption ? "#ffffff" : "rgb(1, 160, 90)" }}
                        disabled={!paymentOption || disablePayment}
                        onClick={this.handleProceedToPay.bind(this)}
                    >
                        Proceed To Pay
              </button>
                </div>
            </FormControl>
        } else {
            return <StripeCheckout handlePayment={this.proceedToPayment.bind(this)} />
        }
    }

    renderPayement(addressSaved) {

        return (<div>
            { addressSaved ?
                this.renderPayementCondition()
                : <>
                    <h4 style={{ color: '#A09E9E' }}>Select payment method</h4>
                    <p style={{ color: '#A09E9E' }}>Select your payment method from the existing one or add new one</p>
                </>
            }
        </div>)
    }

    renderCart() {
        return (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{
                    background: 'white', width: '100%', borderRadius: '5px', marginBottom: '4%',
                    padding: '8%',
                    textAlign: 'left',
                    paddingBottom: '12%'
                }}>
                    <h5>Your Cart <span style={{ color: '#A09E9E' }}>({this.props?.cart?.length} Item)</span></h5>
                    {this.props?.cart?.map((item) => (
                        <>
                            <ProductCard about={item} dontShowImage></ProductCard>
                            <Divider></Divider>
                        </>
                    ))}
                    {this.props.auth && this.props?.cart?.length > 0 &&
                        <div onClick={this.clearTheCart.bind(this)} style={{
                            width: '106px',
                            height: '44px',
                            background: 'rgb(1, 160, 90)',
                            border: '1px solid rgb(1, 160, 90)',
                            color: '#fff',
                            borderRadius: '30px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-around',
                            padding: '0 5px',
                            userSelect: 'none',
                            '&:hover': {
                                boxShadow: '1px 1px 2px #000000'
                            },
                            marginLeft: '30%',
                            marginTop: '5%'
                        }}>
                            <div>Clear Cart</div>
                        </div>
                    }
                </div>
            </div>
        )
    }

    renderInvoice() {
        const { t, gt, p } = this.state;
        return (
            <div style={{ display: 'flex', flexDirection: 'row', marginTop: '4%' }}>
                <div style={{
                    background: 'white', width: '100%', borderRadius: '5px', marginBottom: '4%',
                    padding: '8%',
                    textAlign: 'left',
                    paddingBottom: '12%'
                }}>
                    <h5>Invoice</h5>
                    {!this.props.auth && <div style={{ color: '#A09E9E', fontSize: '12px' }}>Delivery charges may change after signing in</div>}
                    <div style={{ display: 'flex', paddingTop: '30px' }}>
                        <Typography style={{ paddingRight: '8px', fontSize: '12px' }}>
                            <b style={{ color: '#000' }}>SubTotal:</b> AUD {!t ? 0 : t}
                        </Typography>
                        <Typography style={{ paddingRight: '8px', fontSize: '12px' }}>
                            <b style={{ color: '#000' }}>Discount:</b> AUD {p}
                        </Typography>
                        <Typography style={{ paddingRight: '8px', fontSize: '12px' }}>
                            <b style={{ color: '#000' }}>Delivery:</b> AUD {4 * this.props.vendorWiseCart?.length}
                        </Typography>
                        <Typography style={{ fontSize: '12px' }}>
                            <b style={{ color: '#000' }}>Price:</b> AUD {!gt ? 0 : gt}
                        </Typography>
                    </div>
                </div>
            </div>
        )
    }

    renderBox(showTop, showBottom, fillDot, comp) {
        return (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{
                    boxSizing: 'border-box',
                    display: 'flex',
                    position: 'relative',
                    left: '0px',
                    top: '10%',
                    bottom: '0px',
                    width: '30px',
                    marginRight: '10px',
                    flexDirection: 'column',
                    '-webkit-box-align': 'center',
                    'align-items': 'center',
                }}>
                    <div style={{
                        'box-sizing': 'border-box',
                        width: '2px',
                        borderRight: '2px dashed rgb(231, 232, 235)',
                        opacity: showTop ? '1' : '0',
                        marginTop: '4px',
                        height: '36px'
                    }}>

                    </div>
                    {this.renderDot(fillDot)}
                    <div style={{
                        boxSizing: 'border-box',
                        width: '2px',
                        borderRight: '2px dashed rgb(231, 232, 235)',
                        opacity: showBottom ? '1' : '0',
                        flex: '1 1 0%'
                    }}>

                    </div>

                </div>
                <div style={{
                    background: 'white', width: '100%', borderRadius: '5px', marginBottom: '4%',
                    padding: '4%',
                    textAlign: 'left'
                }}>
                    {comp}
                </div>
            </div>
        )
    }


    render() {
        const { classes } = this.props;
        return (
            <div className={classes.container}>
                <Loader show={this.state.showLoader}/>
                <GridContainer>
                    <GridItem xs={12} sm={1} md={1}>
                    </GridItem>
                    <GridItem xs={12} sm={11} md={7}>
                        <div>
                            {!this.props.auth &&
                                (this.renderBox(false, true, false, this.renderSignIn()))
                            }
                            {this.renderBox(!this.props.auth, true, this.state.addressSaved, this.renderAddress(this.props.auth))}
                            {this.renderBox(true, false, false, this.renderPayement(this.state.addressSaved))}
                        </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                        <div>
                            {this.renderCart()}
                            {this.renderInvoice()}
                        </div>
                    </GridItem>
                </GridContainer>
            </div>)
    }
}


const mapStateWithProps = (state) => ({
    cart: state.user.cart,
    vendorWiseCart: state.user.vendorWiseCart,
    coupon: state.user.coupon,
    auth: state.user.auth,
    userDetails: state.user.userDetails
});

const mapDispatchToProps = (dispatch) => ({
    getPromocode: () => dispatch(getPromocode()),
    emptyCart: () => dispatch(emptyCart()),
    updateCart: (product) => dispatch(updateCart(product)),
    getCartItems: () => dispatch(getCartItems()),
    pushEvent: (details) => dispatch(pushEvent(details)),
    toggleSignUp: (isOpen) => dispatch(toggleSignUp(isOpen)),
    getCartItemsLocal: () => dispatch(getCartItemsLocal()),
    placeNewOrder: (checkout) => dispatch(placeNewOrder(checkout)),
    successReport: (message) => dispatch(successReport(message)),
    getUserDetails: () => dispatch(getUserDetails())
});

export default withStyles(styles)(connect(mapStateWithProps, mapDispatchToProps)(CartCheckout));